var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"366px","height":"100%"}},[(_vm.iframeUrl)?_c('iframe',{ref:"iframe",attrs:{"src":_vm.iframeUrl}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }